import { IAngularticsData } from '@mono-repo/data';

export const AngularticsData: IAngularticsData = {
  editBankAccountButton: {
    action: 'click',
    category: 'contract',
    name: 'editBankAccountButton',
    value: '',
  },
};
